function byGroup(list, groups) {
  return list.filter((procedimento) => {
    const procedimentoBelongsToGroup = groups.indexOf(procedimento.tipoProcedimento.identificador) > -1

    if (procedimentoBelongsToGroup) {
      return procedimento
    }
  })
}

export default {
  byGroup,
}
